export function CardSkeleton() {
  return (
    <div className="rounded-lg overflow-hidden">
      <div className="skeleton-shimmer aspect-[2/3] rounded-lg" />
      <div className="mt-2 space-y-1.5 px-0.5">
        <div className="skeleton-shimmer h-3 w-3/4 rounded" />
        <div className="skeleton-shimmer h-2.5 w-1/2 rounded" />
      </div>
    </div>
  );
}
